import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { Timestamp, addDoc, collection } from "firebase/firestore";
import { db } from "../firebase/config";
import { LEAD_TYPES, submitLeadEmail } from "../services/leadEmail";
import { DEALERSHIP_OPTIONS, getDealershipByEmail } from "../data/dealerships";
import { singleCarTestdriveSchema } from "../lib/leadFormSchemas";
import { Button } from "./ui/button";
import {
  Field,
  FieldError,
  FieldGroup,
  FieldLabel,
} from "./ui/field";
import { Input } from "./ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

export const SingleCartestdrive = ({ model, ofertanomer }) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(singleCarTestdriveSchema),
    defaultValues: {
      name: "",
      email: "",
      phone: "",
      dealership: "",
      newsletter: false,
    },
  });
  const navigate = useNavigate();
  const collectionName = "usersTestdrive";

  const sendSingleCartestdrive = async (data) => {
    const selectedDealership = getDealershipByEmail(data.dealership);

    await addDoc(collection(db, collectionName), {
      name: data.name,
      email: data.email,
      phone: data.phone,
      dealership: data.dealership,
      newsletter: data.newsletter,
      date: Timestamp.fromDate(new Date()),
      userModel: model,
      userOffer: ofertanomer,
    });
    // TEMP DISABLED: waiting for separate snippet from agency for this form
    // if (window.gtag) {
    //   const isKuga = model?.toLowerCase().includes("kuga");
    //
    //   window.gtag("event", "conversion", {
    //     send_to: isKuga
    //       ? "AW-17814485194/fvveCOqyzYkcEMrxza5C"
    //       : "AW-17814485194/HOcACLil1d0bEMrxza5C",
    //   });
    // }
    await submitLeadEmail({
      type: LEAD_TYPES.SINGLE_CAR_TESTDRIVE,
      customer: {
        name: data.name,
        email: data.email,
        phone: data.phone,
      },
      dealership: {
        email: data.dealership,
        label: selectedDealership?.label ?? "",
      },
      vehicle: {
        model,
        stockId: ofertanomer,
      },
      campaign: {
        slug: "car-details-testdrive",
      },
      source: {
        pageUrl: window.location.href,
      },
      preferences: {
        newsletter: data.newsletter,
      },
    });

    navigate("/thank-you-testdrive");
  };

  return (
    <div>
      <form
        onSubmit={handleSubmit(sendSingleCartestdrive)}
        className="mx-auto w-full max-w-2xl px-6 py-10 sm:px-8"
        noValidate
      >
        <FieldGroup className="mt-8 gap-5">
          <Field data-invalid={!!errors.name}>
            <FieldLabel htmlFor="name">Име *</FieldLabel>
            <Input id="name" aria-invalid={!!errors.name} {...register("name")} />
            <FieldError>{errors.name?.message}</FieldError>
          </Field>

          <Field data-invalid={!!errors.email}>
            <FieldLabel htmlFor="email">Имейл *</FieldLabel>
            <Input
              id="email"
              type="email"
              placeholder="email@email.com"
              aria-invalid={!!errors.email}
              {...register("email")}
            />
            <FieldError>{errors.email?.message}</FieldError>
          </Field>

          <Field data-invalid={!!errors.phone}>
            <FieldLabel htmlFor="phone">Телефон *</FieldLabel>
            <Input
              id="phone"
              type="text"
              placeholder="+359 87 654321"
              aria-invalid={!!errors.phone}
              {...register("phone")}
            />
            <FieldError>{errors.phone?.message}</FieldError>
          </Field>

          <Field data-invalid={!!errors.dealership}>
            <FieldLabel>Предпочитано представителство *</FieldLabel>
            <Controller
              name="dealership"
              control={control}
              render={({ field }) => (
                <Select value={field.value} onValueChange={field.onChange}>
                  <SelectTrigger
                    className="w-full min-h-11"
                    aria-invalid={!!errors.dealership}
                  >
                    <SelectValue placeholder="Моля, изберете" />
                  </SelectTrigger>
                  <SelectContent>
                    {DEALERSHIP_OPTIONS.map((dealership) => (
                      <SelectItem
                        key={dealership.email}
                        value={dealership.email}
                      >
                        {dealership.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}
            />
            <FieldError>{errors.dealership?.message}</FieldError>
          </Field>

          <label className="flex items-center gap-3 text-sm text-fordBlue">
            <input type="checkbox" className="size-4" {...register("newsletter")} />
            Искам да получавам новини от Ford и Мото-Пфое
          </label>
        </FieldGroup>

        <Button
          type="submit"
          size="lg"
          className="mt-8 min-h-11 px-8 bg-fordBlue text-white hover:bg-fordLight"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Изпращане..." : "Изпрати"}
        </Button>
      </form>
    </div>
  );
};
